"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_2 = require("react");
const styled_1 = require("./styled");
function makeTextField(input) {
    const { props: inputProps = {} } = input || {};
    const TextField = (0, react_2.forwardRef)((args, ref) => {
        const { label, optional, info, children, className, style, variant } = args, props = __rest(args, ["label", "optional", "info", "children", "className", "style", "variant"]);
        const { disabled, name = "textfield" } = props;
        const variantName = disabled ? "disabled" : variant;
        const icons = react_2.Children.toArray(children).reduce((prev, curr) => {
            if ((curr === null || curr === void 0 ? void 0 : curr.type) === styled_1.IconLeft)
                prev.left.push((0, react_2.cloneElement)(curr, Object.assign({ "data-testid": "input-icon-left" }, curr.props)));
            else if ((curr === null || curr === void 0 ? void 0 : curr.type) === styled_1.IconRight)
                prev.right.push((0, react_2.cloneElement)(curr, Object.assign({ "data-testid": "input-icon-right" }, curr.props)));
            else
                prev.left.push(curr);
            return prev;
        }, { left: [], right: [] });
        return (react_1.default.createElement(styled_1.StyledTextField, { optional: optional, className: className, style: style, disabled: disabled, variant: variantName, "data-testid": "textfield" },
            label && (react_1.default.createElement(styled_1.StyledLabel, { htmlFor: name, "data-testid": "label" }, label)),
            react_1.default.createElement(styled_1.StyledInputContainer, { ref: ref, "data-testid": "input-container", disabled: disabled, variant: variantName },
                icons.left,
                icons.right,
                (0, react_2.cloneElement)(input || react_1.default.createElement(styled_1.StyledInput, null), Object.assign(Object.assign({ id: name, "data-testid": "input" }, props), inputProps))),
            info ? (react_1.default.createElement(styled_1.StyledMessage, { "data-testid": "info" }, info)) : null));
    });
    return TextField;
}
exports.default = makeTextField;
//# sourceMappingURL=make-text-field.js.map